export const narrowEnum = <T extends string>(values: readonly T[], value: string, fallback: T): T =>
	values.find((candidate) => candidate === value) ?? fallback;
